import { applyMiddleware, createStore } from 'redux';
import { persistStore, persistReducer, createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import { registerAuthDispatch } from './api/index.js';
import { resetEnhancer, rootReducer } from './reducers';

const migrations = {
    1: (state) => {
        const { router, ...rest } = state;
        return rest;
    },
};

const persistConfig = {
    key: 'root',
    storage: storage,
    version: 1,
    migrate: createMigrate(migrations, { debug: false }),
}

export default function configureStore(preloadedState) {
    const middlewares = [thunkMiddleware];
    const middlewareEnhancer = applyMiddleware(...middlewares);

    const enhancers = [middlewareEnhancer];
    const composedEnhancers = composeWithDevTools(...enhancers);
    const persistedReducer = persistReducer(persistConfig, resetEnhancer(rootReducer));

    const store = createStore(persistedReducer, preloadedState, composedEnhancers);
    registerAuthDispatch(store.dispatch);
    const persistor = persistStore(store);

    return { store, persistor }
}
